import { useState, useEffect } from "react";
const useElementList = (ref, selectors, options) => {
  const [elementList, setElementList] = useState();
  useEffect(() => {
    const handleMutationChange = () => {
      var _a;
      const elements = (_a = ref.current) == null ? void 0 : _a.querySelectorAll(selectors);
      setElementList(elements);
    };
    const mutationObserver = new MutationObserver(handleMutationChange);
    if (ref == null ? void 0 : ref.current) {
      mutationObserver.observe(ref.current, { subtree: true, childList: true, attributes: true, ...options });
    }
    handleMutationChange();
    return () => {
      mutationObserver.disconnect();
    };
  }, [ref, selectors]);
  return elementList;
};
export {
  useElementList
};
//# sourceMappingURL=useElementList.js.map
